<template>
  <div class="cart" :style="{ 'background-color': cartBackgroudColorTheme }">
    <div class="cart-inside-wrapper">
      <h2 class="cart-title section-title">{{ $t("payment.yourOrder") }}</h2>
      <template v-if="cartMenuGroup && cartMenuGroup.length > 0">
        <div
          v-for="(item, index) in cartMenuGroup"
          :key="index"
          class="cart-drinks product-type-section"
        >
          <div class="row" v-if="item">
            <div class="col-6">
              <h3 class="cart-product-type">
                {{ item.quantity ? item.quantity : 1 }} <em>x</em>
                {{ translate("order", item) }}
              </h3>
            </div>
            <div class="col-6 text-right group-price">
              <span class="price">
                {{ formatPrice(menuGroupPrice(item)) }}
              </span>

              <button
                type="button"
                class="remove-product"
                @click="removeFromCart(item)"
              >
                <font-awesome-icon
                  icon="minus-square"
                  :style="{ color: '#ea2222', fontSize: 20 }"
                />
              </button>

              <button
                type="button"
                class="add-product"
                @click="addToCart(item)"
              >
                <font-awesome-icon
                  icon="plus-square"
                  :style="{ color: '#11bd11', fontSize: 20 }"
                />
              </button>
            </div>
          </div>

          <!-- DRINKS -->
          <div
            v-if="
              cartMenuGroupDrinks(item) && cartMenuGroupDrinks(item).length > 0
            "
            class="cart-drinks product-type-section"
          >
            <h3 class="cart-product-type">{{ $t("common.drinks") }}</h3>

            <ul class="cart-items-list">
              <li
                v-for="(drink, di) in cartMenuGroupDrinks(item)"
                class="cart-item"
                :key="di"
              >
                <span class="name">
                  {{ translate("order", drink) }}
                  <span v-if="parseFloat(drink.additional_charge) > 0">
                    {{ `(+ ${formatPrice(drink.additional_charge)})` }}
                  </span></span
                >

                <textarea
                  v-if="drink.isAllowComment"
                  :ref="`${drink.name}-notes`"
                  @input="saveNotes(drink, `${drink.name}-notes`)"
                  :placeholder="placeholderNotesDrinks()"
                  class="notes"
                  :id="`${drink.name}-notes`"
                  :name="`${drink.name}-notes`"
                  :value="drink.notes"
                  rows="1"
                  cols="50"
                  maxlength="250"
                ></textarea>
              </li>
            </ul>
          </div>

          <!-- PRIMERO -->
          <div
            v-if="cartStarters(item) && cartStarters(item).length > 0"
            class="cart-food product-type-section"
          >
            <h3 class="cart-product-type text-uppercase">
              {{ $t("common.first") }}
            </h3>

            <ul class="cart-items-list">
              <li
                v-for="(starter, si) in cartStarters(item)"
                class="cart-item"
                :key="si"
              >
                <span class="name"
                  >{{ translate("order", starter) }}
                  <span v-if="parseFloat(starter.additional_charge) > 0">
                    {{ `(+ ${formatPrice(starter.additional_charge)})` }}
                  </span>
                </span>

                <textarea
                  v-if="starter.isAllowComment"
                  :ref="`${starter.name}-notes`"
                  @input="saveNotes(starter, `${starter.name}-notes`)"
                  :placeholder="placeholderNotesFood()"
                  class="notes"
                  :id="`${starter.name}-notes`"
                  :name="`${starter.name}-notes`"
                  :value="starter.notes"
                  rows="1"
                  cols="50"
                  maxlength="250"
                ></textarea>
              </li>
            </ul>
          </div>

          <!-- SEGUNDO -->
          <div
            v-if="cartMainCourse(item) && cartMainCourse(item).length > 0"
            class="cart-food product-type-section"
          >
            <h3 class="cart-product-type text-uppercase">
              {{ $t("common.second") }}
            </h3>

            <ul class="cart-items-list">
              <li
                v-for="(maincourse, mi) in cartMainCourse(item)"
                class="cart-item"
                :key="mi"
              >
                <span class="name"
                  >{{ translate("order", maincourse) }}
                  <span v-if="parseFloat(maincourse.additional_charge) > 0">
                    {{
                      `(+ ${formatPrice(maincourse.additional_charge)})`
                    }}</span
                  ></span
                >

                <textarea
                  v-if="maincourse.isAllowComment"
                  :ref="`${maincourse.name}-notes`"
                  @input="saveNotes(maincourse, `${maincourse.name}-notes`)"
                  :placeholder="placeholderNotesFood()"
                  class="notes"
                  :id="`${maincourse.name}-notes`"
                  :name="`${maincourse.name}-notes`"
                  :value="maincourse.notes"
                  rows="1"
                  cols="50"
                  maxlength="250"
                ></textarea>
              </li>
            </ul>
          </div>

          <!--  DESSERTS -->
          <div
            v-if="
              cartMenuGroupDessert(item) &&
                cartMenuGroupDessert(item).length > 0
            "
            class="cart-food product-type-section"
          >
            <h3 class="cart-product-type">{{ $t("common.dessert") }}</h3>

            <ul class="cart-items-list">
              <li
                v-for="(dessert, di) in cartMenuGroupDessert(item)"
                class="cart-item"
                :key="di"
              >
                <span class="name"
                  >{{ translate("order", dessert) }}
                  <span v-if="parseFloat(dessert.additional_charge) > 0">{{
                    `(+ ${formatPrice(dessert.additional_charge)})`
                  }}</span></span
                >

                <textarea
                  v-if="dessert.isAllowComment"
                  :ref="`${dessert.name}-notes`"
                  @input="saveNotes(dessert, `${dessert.name}-notes`)"
                  :placeholder="placeholderNotesFood()"
                  class="notes"
                  :id="`${dessert.name}-notes`"
                  :name="`${dessert.name}-notes`"
                  :value="dessert.notes"
                  rows="1"
                  cols="50"
                  maxlength="250"
                ></textarea>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template>
        <!-- DRINKS -->
        <div v-if="cartDrinks.length" class="cart-drinks product-type-section">
          <h3 class="cart-product-type">{{ $t("common.drinks") }}</h3>

          <ul class="cart-items-list">
            <li
              v-for="(item, index) in cartDrinks"
              class="cart-item"
              :key="index"
            >
              <span class="quantity">
                {{ item.quantity }}
                <em>x</em>
              </span>

              <span class="name">{{ translate("order", item) }}</span>

              <span class="size">{{ sizeText(item) }}</span>

              <span class="price">
                {{ formatPrice(item.price * item.quantity) }}
              </span>

              <button
                type="button"
                class="remove-product"
                @click="removeFromCart(item)"
              >
                <font-awesome-icon
                  icon="minus-square"
                  :style="{ color: '#ea2222', fontSize: 20 }"
                />
              </button>

              <button
                type="button"
                class="add-product"
                @click="addToCart(item)"
              >
                <font-awesome-icon
                  icon="plus-square"
                  :style="{ color: '#11bd11', fontSize: 20 }"
                />
              </button>

              <textarea
                v-if="item.isAllowComment"
                :ref="`${item.name}-notes`"
                @input="saveNotes(item, `${item.name}-notes`)"
                :placeholder="placeholderNotesDrinks()"
                class="notes"
                :id="`${item.name}-notes`"
                :name="`${item.name}-notes`"
                :value="item.notes"
                rows="1"
                cols="50"
                maxlength="250"
              ></textarea>
            </li>
          </ul>
        </div>

        <!-- FOOD -->
        <div v-if="cartFood.length" class="cart-food product-type-section">
          <h3 class="cart-product-type">{{ $t("common.food") }}</h3>

          <ul class="cart-items-list">
            <li
              v-for="(item, index) in cartFood"
              class="cart-item"
              :key="index"
            >
              <span class="quantity">
                {{ item.quantity }}
                <em>x</em>
              </span>

              <span class="name">{{ translate("order", item) }}</span>

              <span class="price">
                {{ weight(item) + formatPrice(item.price * item.quantity) }}
              </span>

              <button
                type="button"
                class="remove-product"
                @click="removeFromCart(item)"
              >
                <font-awesome-icon
                  icon="minus-square"
                  :style="{ color: '#ea2222', fontSize: 20 }"
                />
              </button>

              <button
                type="button"
                class="add-product"
                @click="addToCart(item)"
              >
                <font-awesome-icon
                  icon="plus-square"
                  :style="{ color: '#11bd11', fontSize: 20 }"
                />
              </button>

              <textarea
                v-if="item.isAllowComment"
                :ref="`${item.name}-notes`"
                @input="saveNotes(item, `${item.name}-notes`)"
                :placeholder="placeholderNotesFood()"
                class="notes"
                :id="`${item.name}-notes`"
                :name="`${item.name}-notes`"
                :value="item.notes"
                rows="1"
                cols="50"
                maxlength="250"
              ></textarea>
            </li>
          </ul>
        </div>

        <!--  DESSERTS -->
        <div v-if="cartDessert.length" class="cart-food product-type-section">
          <h3 class="cart-product-type">{{ $t("common.dessert") }}</h3>

          <ul class="cart-items-list">
            <li
              v-for="(item, index) in cartDessert"
              class="cart-item"
              :key="index"
            >
              <span class="quantity">
                {{ item.quantity }}
                <em>x</em>
              </span>

              <span class="name">{{ translate("order", item) }}</span>

              <span class="price">
                {{ formatPrice(item.price * item.quantity) }}
              </span>

              <button
                type="button"
                class="remove-product"
                @click="removeFromCart(item)"
              >
                <font-awesome-icon
                  icon="minus-square"
                  :style="{ color: '#ea2222', fontSize: 20 }"
                />
              </button>

              <button
                type="button"
                class="add-product"
                @click="addToCart(item)"
              >
                <font-awesome-icon
                  icon="plus-square"
                  :style="{ color: '#11bd11', fontSize: 20 }"
                />
              </button>

              <textarea
                v-if="item.isAllowComment"
                :ref="`${item.name}-notes`"
                @input="saveNotes(item, `${item.name}-notes`)"
                :placeholder="placeholderNotesFood()"
                class="notes"
                :id="`${item.name}-notes`"
                :name="`${item.name}-notes`"
                :value="item.notes"
                rows="1"
                cols="50"
                maxlength="250"
              ></textarea>
            </li>
          </ul>
        </div>
      </template>
      <div
        v-if="settings && settings.paymentMethod !== 'nomobilepayment'"
        class="total-price"
        :style="{ 'border-color': cartBorderTopColorTheme }"
      >
        <span class="label">{{ $t("payment.total") }}</span>
        <span class="total-price-value">{{ formatPrice(totalPrice) }}</span>
      </div>

      <div class="general-notes">
        <textarea
          :placeholder="generalPlaceholderNotes()"
          class="notes"
          style="font-size: 12px"
          rows="1"
          cols="50"
          v-model="inputGeneralComment"
          @input="saveComment"
          maxlength="250"
        ></textarea>
      </div>

      <div
        class="terms-condition-main"
        v-if="!cartIsEmpty && canBeDirectPayment && !isAdmin"
      >
        <v-checkbox v-model="checkboxTermsCondition">
          <template v-slot:label>
            <div>
              &nbsp;
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a target="_blank" href="/terms" @click.stop v-on="on">
                    {{ $t("payment.acceptTermsAndConditions") }}
                  </a>
                </template>
                {{ $t("payment.acceptTermsAndConditions") }}
              </v-tooltip>
            </div>
          </template>
        </v-checkbox>
      </div>

      <PaymentMethods
        v-if="!cartIsEmpty && canBeDirectPayment && !isAdmin"
        :drinks-collection="drinksCollection"
        :food-collection="foodCollection"
        :dessert-collection="dessertCollection"
        :disable-payment-button="disablePaymentButton"
        :total-price="totalPrice"
        :canBeDirectPayment="canBeDirectPayment"
        :cart="cart"
        :tableQR="tableQR"
        @checkQRUpdate="checkQRUpdate($event)"
      ></PaymentMethods>

      <button
        @click="submitRequest"
        class="checkout-button"
        :style="[
          { 'border-radius': buttonBorderRadiusTheme },
          { color: colorsGeneralPrimary }
        ]"
        :class="{ disabled: disablePaymentButton }"
        v-if="!canBeDirectPayment && !isAdmin"
      >
        <span>{{ $t("common.askFor") }}</span>
      </button>

      <v-alert
        v-if="cart && cart.length > 0 && !activeMenuProducts"
        class="mt-5"
        type="error"
        outlined
        prominent
        >{{ $t("cart.productOrderNotAvailable") }}
      </v-alert>

      <Loader
        :dialog-loader="loading"
        :message="$t('common.charging')"
      ></Loader>

      <SharedItems
        ref="sharedItemModalRef"
        @submit="checkout"
        :isAdmin="false"
      ></SharedItems>
    </div>
    <QrValidationModal
      :check-q-r="checkQR"
      @closeQrValidationModal="closeQrValidationModal"
      :isAdmin="isAdmin"
    ></QrValidationModal>
    <InsertWeightModal ref="insertWeightModalRef" />
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import { deletePayment, paymentsCollection } from "@/collections/payments";
import { firestoreTimestamp } from "@/firebaseConfig";
import Loader from "../../common/Loader";
import SharedItems from "@/components/public/cart/SharedItems";
import moment from "moment";
import QrValidationModal from "@/components/public/modals/QrValidationModal";
import PaymentMethods from "@/components/public/payment/PaymentMethods";
import InsertWeightModal from "@/components/public/modals/InsertWeightModal.vue";

import utilMixin from "@/mixins/common/utilMixin";
import {
  updateOrder,
  getLastOrderByTime,
  getOpenOrdersByTableQR
} from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { qrCollection } from "@/collections/qrs";
import { scheduleFoodCollection } from "@/collections/scheduleFood";
import { scheduleDrinksCollection } from "@/collections/scheduleDrinks";
import { scheduleDessertCollection } from "@/collections/scheduleDessert";
import { scheduleByMenuCollection } from "@/collections/scheduleByMenu";
import { scheduleMenuGroupCollection } from "@/collections/scheduleMenuGroup";
import { dessertCollection } from "@/collections/dessert";
import { foodCollection } from "@/collections/food";
import { drinksCollection } from "@/collections/drinks";
import { menusCollection } from "@/collections/menus";
import { menuGroupCollection } from "@/collections/menuGroup";
import { categoriesCollection } from "@/collections/categories";

const NO_QR = "NO QR";

export default {
  name: "MiniCart",
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loader,
    SharedItems,
    QrValidationModal,
    PaymentMethods,
    InsertWeightModal
  },
  data() {
    return {
      categoriesCollection: [],
      drinksCollection: [],
      foodCollection: [],
      dessertCollection: [],
      menusCollection: [],
      menuGroupCollection: [],
      scheduleDrinks: [],
      scheduleFood: [],
      scheduleDessert: [],
      scheduleByMenu: [],
      scheduleByMenuGroup: [],
      qrCollection: [],
      paymentsCollection: [],
      ordersTotalByTable: [],
      dialogLoader: false,
      inputGeneralComment: "",
      checkQR: false,
      checkboxTermsCondition: false
    };
  },
  firestore() {
    return {
      categoriesCollection: categoriesCollection,
      drinksCollection: drinksCollection,
      foodCollection: foodCollection,
      dessertCollection: dessertCollection,
      menusCollection: menusCollection.where("active", "==", true),
      menuGroupCollection: menuGroupCollection.where("active", "==", true),
      scheduleDrinks: scheduleDrinksCollection,
      scheduleDessert: scheduleDessertCollection,
      scheduleFood: scheduleFoodCollection,
      scheduleByMenu: scheduleByMenuCollection,
      scheduleByMenuGroup: scheduleMenuGroupCollection,
      qrCollection: qrCollection.where("active", "==", true).orderBy("table"),
      paymentsCollection: paymentsCollection.where("payment_on", "==", null),
      ordersTotalByTable: ordersTotalByTableCollection
    };
  },
  computed: {
    email() {
      return this.$store.getters.getEmail(false);
    },
    activeMenuProducts() {
      // check active menus
      let active_products_ids = [];
      this.menusCollection.forEach(item => {
        let menuSchedule = this.scheduleByMenu.find(x => x.menuId === item.id);

        if (menuSchedule && !this.disableMenu(menuSchedule.schedule)) {
          let mergeArray = [
            ...item.food_ids,
            ...item.drink_ids,
            ...item.dessert_ids
          ];
          active_products_ids.push(...mergeArray);
        }
      });

      // check active comidas
      let activeFoodIds = [];
      if (!this.disableProducts(this.scheduleFood)) {
        let activeFoodProducts = this.foodCollection.filter(item => {
          if (item.canBeShowInFood === true) {
            return item;
          }
        });

        if (activeFoodProducts && activeFoodProducts.length > 0) {
          activeFoodIds = activeFoodProducts.map(item => {
            return item.id;
          });
        }
      }
      active_products_ids = [...active_products_ids, ...activeFoodIds];

      // check active drinks
      let activeDrinksIds = [];
      if (!this.disableProducts(this.scheduleDrinks)) {
        let activeDrinksProducts = this.drinksCollection.filter(item => {
          if (item.canBeShowInDrinks === true) {
            return item;
          }
        });
        if (activeDrinksProducts && activeDrinksProducts.length > 0) {
          activeDrinksIds = activeDrinksProducts.map(item => {
            return item.id;
          });
        }
      }
      active_products_ids = [...active_products_ids, ...activeDrinksIds];

      // check active desserts
      let activeDessertIds = [];
      if (!this.disableProducts(this.scheduleDessert)) {
        let activeDessertProducts = this.dessertCollection.filter(item => {
          if (item.canBeShowInDessert === true) {
            return item;
          }
        });
        if (activeDessertProducts && activeDessertProducts.length > 0) {
          activeDessertIds = activeDessertProducts.map(item => {
            return item.id;
          });
        }
      }

      active_products_ids = [...active_products_ids, ...activeDessertIds];

      this.menuGroupCollection.forEach(item => {
        let menuGroupSchedule = this.scheduleByMenuGroup.find(
          x => x.menuId === item.id
        );

        if (
          menuGroupSchedule &&
          !this.disableMenu(menuGroupSchedule.schedule)
        ) {
          active_products_ids.push(item.id);
        }
      });

      // cart product ids
      let cartClone = JSON.parse(JSON.stringify(this.cart));
      let cartProductIds = cartClone.map(item => {
        return item.product_id;
      });

      return this.arrayContainsArray(active_products_ids, cartProductIds);
    },
    payments() {
      return this.arrayGroupBy(this.paymentsCollection, "tableQR")[
        this.tableQR
      ];
    },
    tableQR() {
      if (!this.isAdmin) {
        return this.$store.state.tableQR
          ? this.$store.state.tableQR
          : localStorage.getItem("tableQR");
      } else {
        return this.$store.state.adminTableQR
          ? this.$store.state.adminTableQR
          : localStorage.getItem("adminTableQR");
      }
    },
    canBeDirectPayment() {
      let table = this.qrCollection.find(x => x.table === this.tableQR);
      let zone = null;
      if (table) {
        zone = this.qrZones.find(x => x.id === table.zone_id);
      }
      return zone ? zone.acceptDirectPayment : false;
    },
    loading() {
      return this.dialogLoader || this.$store.state.loading;
    },
    cart() {
      if (!this.isAdmin) {
        return this.$store.state.cart;
      } else {
        return this.$store.state.admincart;
      }
    },
    cartDrinks() {
      const { drinks } = this.$store.state.productTypeIds;
      let self = this;

      if (self.drinksCollection.length === 0) {
        return [];
      }

      return this.cart.filter(item => {
        let product = self.drinksCollection.find(p => p.id === item.product_id);
        return (
          item.product_type_id === drinks &&
          product &&
          product.stock > 0 &&
          !item.isMenuGroupProduct
        );
      });
    },
    cartFood() {
      const { food } = this.$store.state.productTypeIds;
      let self = this;

      if (self.foodCollection.length === 0) {
        return [];
      }

      return this.cart.filter(item => {
        self.foodCollection.find(p => p.id === item.product_id);
        return item.product_type_id === food && !item.isMenuGroupProduct;
      });
    },
    cartDessert() {
      const { dessert } = this.$store.state.productTypeIds;
      let self = this;

      if (self.dessertCollection.length === 0) {
        return [];
      }

      return this.cart.filter(item => {
        self.dessertCollection.find(p => p.id === item.product_id);
        return item.product_type_id === dessert && !item.isMenuGroupProduct;
      });
    },
    menuGroup() {
      let menuGroup = this.menuGroupCollection.filter(item => {
        if (this.cart && this.cart.length > 0) {
          let menuGroup = this.cart.find(x => x.menu_group_id === item.id);
          if (menuGroup) {
            return item;
          }
        }
      });

      return menuGroup && menuGroup.length > 0 ? menuGroup : [];
    },
    cartMenuGroup() {
      let self = this;
      return this.cart.filter(item => {
        let menuGroup = self.menuGroupCollection.find(
          x => x.id === item.menu_group_id
        );
        if (menuGroup) {
          return item;
        }
      });
    },
    totalPrice() {
      let total = 0;
      const { drinks, food, dessert } = this.$store.state.productTypeIds;
      let self = this;

      this.cartMenuGroup.forEach(item => {
        total += this.menuGroupPrice(item);
      });

      this.cart.forEach(item => {
        if (item.product_type_id === drinks && !item.isMenuGroupProduct) {
          let product = self.drinksCollection.find(
            d => d.id === item.product_id
          );
          if (product && product.stock > 0) {
            total += item.price * item.quantity;
          }
        }

        if (item.product_type_id === food && !item.isMenuGroupProduct) {
          let product = self.foodCollection.find(f => f.id === item.product_id);
          if (product && product.stock > 0) {
            total += item.price * item.quantity;
          }
        }

        if (item.product_type_id === dessert && !item.isMenuGroupProduct) {
          let product = self.dessertCollection.find(
            f => f.id === item.product_id
          );
          if (product && product.stock > 0) {
            total += item.price * item.quantity;
          }
        }
      });

      return total;
    },

    stripeCheckoutItemsIsEmpty() {
      return this.$store.state.stripeCheckoutItems.length === 0;
    },
    cartIsEmpty() {
      return this.cart.length === 0;
    },
    areStripeVariablesEmpty() {
      return utilMixin.areStripeVariablesEmpty();
    },
    disablePaymentButton() {
      return (
        (!this.checkboxTermsCondition && this.canBeDirectPayment) ||
        this.cartIsEmpty ||
        (this.stripeCheckoutItemsIsEmpty && !this.areStripeVariablesEmpty) ||
        !this.activeMenuProducts
      );
    }
  },
  mounted() {
    this.inputGeneralComment = !this.isAdmin
      ? localStorage.getItem("general-comment") || ""
      : localStorage.getItem("admin-general-comment") || "";
  },
  methods: {
    weight(item) {
      return item.weight
        ? item.weight + "Kg   \xa0\xa0\xa0\xa0\xa0\xa0\xa0"
        : "";
    },
    checkQRUpdate(event) {
      this.checkQR = event;
    },
    arrayContainsArray(superset, subset) {
      return subset.every(function(value) {
        return superset.indexOf(value) >= 0;
      });
    },
    async submitRequest() {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }
      await this.resolveCloseOpenOrders();

      // check cart item length is greater then 20
      const { cart } = this.$store.state;
      if (cart.length > 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }
      let hasMenuGroupProduct = cart.some(x => x.isMenuGroupProduct);
      let hasSharedItem = cart.find(x => x.canBeShared || false);
      setTimeout(async () => {
        if (hasSharedItem && !hasMenuGroupProduct) {
          this.$refs.sharedItemModalRef.openDialog();
        } else {
          await this.checkout();
        }
      }, 100);
    },
    async resolveCloseOpenOrders() {
      try {
        let lastOrders = await getLastOrderByTime();

        let orderTotal = this.ordersTotalByTable.find(
          x => x.tableQR === this.tableQR
        );

        if (
          lastOrders &&
          lastOrders[0] &&
          orderTotal &&
          lastOrders[0].email !== this.email &&
          orderTotal.remaining === 0
        ) {
          // If the last order does not correspond to the current user
          // and the order total is paid, the account must be closed
          await this.closeOpenOrders();
        }
      } catch (error) {
        this.setlogError(
          "get_last_order_by_Time",
          "Obtained error message in resolveCloseOpenOrders()",
          error.stack,
          this.$options.name
        );
      }
    },
    async closeOpenOrders() {
      try {
        let now = moment().format();
        let self = this;
        let orders = await getOpenOrdersByTableQR(self.tableQR);

        orders.forEach(async item => {
          try {
            if (item.metadata) {
              // eslint-disable-next-line no-unused-vars
              for (const [quantity, metadata] of Object.entries(
                item.metadata
              )) {
                item.metadata[quantity].isPaid = true;
              }
            }
            item.isOpen = false;
            item.orderClosedAt = now;
            await updateOrder(item.id, item);
          } catch (error) {
            this.setlogError(
              "update_order",
              "Obtained error message in closeOpenOrders()",
              error.stack,
              this.$options.name
            );
          }
        });

        // Remove unpaid payment requests
        this.payments &&
          this.payments.forEach(async payment => {
            try {
              await deletePayment(payment.id);
            } catch (error) {
              this.setlogError(
                "delete_payment",
                "Obtained error message in closeOpenOrders()",
                error.stack,
                this.$options.name
              );
            }
          });

        await this.updateOrderTotalAmount();
      } catch (error) {
        this.setlogError(
          "get_open_orders_by_table_QR",
          "Obtained error message in closeOpenOrders()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateOrderTotalAmount() {
      let time = firestoreTimestamp.fromDate(new Date());
      try {
        let orderTotal = this.ordersTotalByTable.find(
          x => x.tableQR === this.tableQR
        );

        if (orderTotal) {
          orderTotal.remaining = 0;
          orderTotal.time = time;
          await updateOrderTotalByTable(this.tableQR, orderTotal);
        }
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in updateOrderTotalAmount()",
          error.stack,
          this.$options.name
        );
      }
    },
    saveComment() {
      !this.isAdmin
        ? localStorage.setItem("general-comment", this.inputGeneralComment)
        : localStorage.setItem(
            "admin-general-comment",
            this.inputGeneralComment
          );
    },
    async checkout() {
      let self = this;
      this.dialogLoader = true;
      localStorage.setItem("lastLand", "checkout");
      localStorage.setItem("isPaid", "false");

      let interval = setInterval(() => {
        let allSkusAdded = true;
        let cart = [...self.$store.state.cart];
        cart.forEach(cartItem => {
          if (!cartItem.stripeSku) {
            allSkusAdded = false;
          }
        });

        if (allSkusAdded || this.areStripeVariablesEmpty) {
          clearInterval(interval);
          self.dialogLoader = false;
          self.$router.push("/success/_/");
        }
      }, 1000);
    },
    removeFromCart(item) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }

      let menuGroup = this.menuGroupCollection.find(
        menuGroup => menuGroup.id === item.id
      );
      if (menuGroup) {
        this.cartStarters.forEach(x => {
          if (x.menu_group_id === item.id) {
            this.$store.commit("removeFromCart", x);
          }
        });

        this.cartMainCourse.forEach(x => {
          if (x.menu_group_id === item.id) {
            this.$store.commit("removeFromCart", x);
          }
        });

        this.cartMenuGroupDrinks.forEach(x => {
          if (x.menu_group_id === item.id) {
            this.$store.commit("removeFromCart", x);
          }
        });

        this.cartMenuGroupDessert.forEach(x => {
          if (x.menu_group_id === item.id) {
            this.$store.commit("removeFromCart", x);
          }
        });
      } else {
        console.log(item);
        this.$store.commit("removeFromCart", item);
      }
    },
    addToCart(item) {
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        return;
      }
      if (item.weight) {
        this.$refs.insertWeightModalRef.open(item, this.isAdmin);
        return;
      }
      this.$store.commit("addToCart", { item: item, update: true });
    },
    saveNotes(item, ref) {
      item.notes = document.getElementById(ref).value;
      this.$store.commit("updateNotesInCart", item);
    },
    placeholderNotesDrinks() {
      return this.$t("payment.placeholderNotesDrinks");
    },
    placeholderNotesFood() {
      return this.$t("payment.placeholderNotesFood");
    },
    generalPlaceholderNotes() {
      return this.$t("payment.generalPlaceHolderNotes");
    },
    closeQrValidationModal() {
      this.checkQR = false;
    },
    menuGroupPrice(item) {
      let price = 0;
      price = item ? parseFloat(item.price) : 0;

      if (item.starters && item.starters.length > 0) {
        item.starters.forEach(starter => {
          price += parseFloat(starter.additional_charge);
        });
      }

      if (item.maincourse && item.maincourse.length > 0) {
        item.maincourse.forEach(main => {
          price += parseFloat(main.additional_charge);
        });
      }

      if (item.desserts && item.desserts.length > 0) {
        item.desserts.forEach(dessert => {
          price += parseFloat(dessert.additional_charge);
        });
      }
      if (item.drinks && item.drinks.length > 0) {
        item.drinks.forEach(drink => {
          price += parseFloat(drink.additional_charge);
        });
      }

      return parseFloat(price) * item.quantity;
    },
    cartStarters(item) {
      if (this.cartMenuGroup.length === 0) {
        return [];
      }
      let foundCartMenu = this.cartMenuGroup.find(x => {
        if (item.cart_item_id === x.cart_item_id) return x;
      });
      return foundCartMenu ? foundCartMenu.starters : [];
    },
    cartMainCourse(item) {
      if (this.cartMenuGroup.length === 0) {
        return [];
      }
      let foundCartMenu = this.cartMenuGroup.find(x => {
        if (item.cart_item_id === x.cart_item_id) return x;
      });
      return foundCartMenu ? foundCartMenu.maincourse : [];
    },
    cartMenuGroupDessert(item) {
      let self = this;

      if (self.cartMenuGroup.length === 0) {
        return [];
      }

      let foundCartMenu = this.cartMenuGroup.find(x => {
        if (item.cart_item_id === x.cart_item_id) return x;
      });
      return foundCartMenu ? foundCartMenu.desserts : [];
    },
    cartMenuGroupDrinks(item) {
      let self = this;

      if (self.cartMenuGroup.length === 0) {
        return [];
      }

      let foundCartMenu = this.cartMenuGroup.find(x => {
        if (item.cart_item_id === x.cart_item_id) return x;
      });
      return foundCartMenu ? foundCartMenu.drinks : [];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  // font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  letter-spacing: 3px;
  color: rgba(#000, 0.5);
  background: #fff;
  text-transform: uppercase;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
